<template>
    <div class="mb-5 lg:hidden">
        <a class="cursor-pointer flex items-center" @click="back">
            <img loading="lazy" src="/img/icons/left-arrow.svg" class="mr-2">
            <span class="go-back-link font-bold">{{ trans.get('customer.go-back') }}</span>
        </a>
    </div>
</template>

<script>
export default {
    methods: {
        back() {
            this.$store.commit('customerSetMobileMenuShown', true);
        },
    },
}
</script>
